import { GroupField } from "../../../../app/user/profile/profileUtils";


export const sortDataByWeight = (data: GroupField[]): GroupField[] => {
  return data
    .map((item, index) => ({ item, index }))
    .sort((a, b) => {
      const weightDiff = (a.item.weight || 0) - (b.item.weight || 0);
      if (weightDiff !== 0) {
        return weightDiff;
      }
      return a.index - b.index;
    })
    .map((entry) => entry.item);
}